/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetLightningInvoiceRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {GetLightningInvoiceResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const getLightningInvoice = (request: GetLightningInvoiceRequest, options?: CashRequestOptions) => post<GetLightningInvoiceRequest, GetLightningInvoiceResponse>("/2.0/cash/get-lightning-invoice", request, {...options, rejectOnError: true })